module.exports = __webpack_public_path__ + "1cc1731b965b71bef42eb8b6cdf33b4b.svg";